import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const Portal = ({ id, children }) => {
  const container = useRef();

  useEffect(() => {
    const existing = document.getElementById(id);

    // Re-use existing container if possible
    if (existing) {
      container.current = existing;
      return;
    }

    // Render a new container
    const newEl = document.createElement('div');
    newEl.setAttribute('id', id);
    document.body.appendChild(newEl);
    container.current = newEl;
  }, [id]);

  if (!container.current) return null;
  return createPortal(children, container.current);
};

Portal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
};

Portal.defaultProps = {
  children: null,
};

export default Portal;
